export default __webpack_public_path__ + "static/media/yhjt.7573514e.png";